import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { MdOutlineMoreHoriz } from "react-icons/md"

const _MoreIcon = () => {
  return (
    <Flex
      color="#FFFFFF"
      border={"2px solid #FFFFFF"}
      background="rgba(0, 0, 0, 0.2)"
      borderRadius="50%"
      onMouseDown={e => e.preventDefault()}
      className="icon-ios"
    >
      <MdOutlineMoreHoriz size="1.4rem" />
    </Flex>
  )
}

export const MoreIcon = React.memo(_MoreIcon)
